import goodsList from "../../assets/data/goodsList";

const SummaryBanner = () => {
  return (
    <div className="delivery-banner summary-banner">
      <div className="goods-description-section">
        <h4 className="title">
          Lists of Unacceptable Description of goods.
        </h4>
        <p className="desc">
          Review the list of acceptable and unacceptable goods descriptions to ensure your shipment meets
          compliance standards. Use clear, specific terms to avoid delays, penalties, or rejections during processing.
        </p>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Unacceptable</th>
                <th>Acceptable</th>
              </tr>
            </thead>
            <tbody>
              {goodsList.map((item, index) => (
                <tr key={index}>
                  <td>{item.unacceptable}</td>
                  <td>{item.acceptable}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SummaryBanner;